/**
 * Хук данных экрана «Контроль сроков» (SLA) менеджеру/владельцу.
 *
 * Бэк: GET /v1/admin/requests/sla-breached?limit=100 (internal/request,
 * handlers_extra.ListSLABreached) — текущий набор просроченных заявок отеля.
 * Ответ — { items: ManagerRequest[], count } (тот же проекшн заявки, что и
 * лента /v1/admin/requests). RBAC: manager/owner (role-exception на
 * /v1/admin/* в cmd/api/main.go).
 *
 * Server-state только через React Query; авто-refetch раз в минуту, чтобы
 * просрочки на экране менеджера не «застывали».
 */
import { useQuery } from '@tanstack/react-query';
import { customFetch } from '@hsc/api-client';
import type { ManagerRequest } from '@hsc/types';

export interface SlaBreachedResponse {
  items: ManagerRequest[];
  count: number;
}

export function useSlaBreached(limit = 100) {
  return useQuery<SlaBreachedResponse>({
    queryKey: ['requests', 'sla-breached', limit],
    queryFn: async () => {
      const raw = await customFetch<{ items?: ManagerRequest[]; count?: number }>({
        url: '/admin/requests/sla-breached',
        method: 'GET',
        params: { limit },
      });
      return { items: raw.items ?? [], count: raw.count ?? raw.items?.length ?? 0 };
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
